import type { SyntheticEvent } from "react";
import { useState } from "react";

import { showToast } from "../utils/Toasts";

import { Button, Alert } from "react-bootstrap";

import supabase from "../utils/Supabase";

function ResendRegistration() {
  const [email, setEmail] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const [showLoginDetails, setShowLoginDetails] = useState(true);

  async function resendRegistration(event: SyntheticEvent) {
    event.preventDefault();

    if (email.trim().length === 0) {
      setErrorMessage("Please enter a valid email address.");
      return;
    }

    setShowLoginDetails(false);
    setErrorMessage("");

    const { data, error } = await supabase.auth.resend({
        type: 'signup',
        email: email,
        options: {
          emailRedirectTo: `${window.location.origin}/database`
        }
    });

    if (data) {
        console.log(data);
    }

    if (!error) {
      return;
    }

    showToast("error",
      "Something went wrong when trying to resend your registration link, please retry later"
    );
    setShowLoginDetails(true);
  }

  return (
    <>
      <main className="d-flex" style={{ flex: "max-content" }}>
        <div className="m-auto">

          <div className="mt-3">
            {showLoginDetails ? (
              <form className="form" onSubmit={resendRegistration}>
                <h1>That didn't work!</h1>
                <p>Sorry, the link you used was expired.</p>
                <p>If you're trying to confirm your email, please use the form below to send a new registration link.</p>

                {errorMessage && (
                  <Alert
                    key="danger"
                    variant="danger"
                    className="mt-3"
                    dismissible
                    onClose={() => setErrorMessage("")}
                  >
                    {errorMessage}
                  </Alert>
                )}

                <input
                  type="email"
                  className="form-control mt-3"
                  placeholder="example@email.com"
                  arial-label="Enter your email"
                  onChange={(e) => {
                    setErrorMessage("");
                    setEmail(e.target.value)
                  }}
                />

                <Button className="form-control mt-3" type="submit">
                  Resend registration email
                </Button>
              </form>
            ) : (
              <Alert key="info" variant="info">
                  If your account still needs confirmation, you'll receive an email.<br/>
                  Please note that the link expires after <strong>30 minutes</strong>.
              </Alert>
            )}
          </div>
        </div>
      </main>
    </>
  );
}

export default ResendRegistration;